export default {
  integrate: 'Integrate',
  integrations: 'Integrations'
}
